import { workspaceModel } from 'APP/model/model';
import Entities from 'STORE';

export async function removeWorkspaceMember(userIds: string[]): Promise<boolean> {
  try {
    await workspaceModel.removeParticipants(userIds);

    const workspace = Entities.workspace;
    workspace.updatedMembersCount(workspace.membersCount - userIds.length);

    return true;
  } catch {
    return false;
  }
}
